<template>
  <div>
    <div class="ShowCreateMelkUser">
      <el-scrollbar height="100%" ref="scrollbar">
        <div class="createMelkHeader phoneBookHeader">
          <div class="createMelkHeaderContainer">
            <div class="createMelkHeaderTitle">
              <h1>بایگانی فایل ها</h1>
            </div>
            <div class="showFormBtn" @click="formTypeHandler('add')">
              <i class="fa-solid fa-plus"></i>
            </div>
            <div @click="closeBtn" class="ShowIconVsIcon">
              <i class="fas fa-arrow-left" style="font-size: 24px"></i>
            </div>
          </div>
        </div>
        <div class="showFileMain mainContainer">
          <div class="mainFilterBox" :class="{ show: showFilter }">
            <div class="fiterboxHeader">
              <div class="filterTitle">فیلتر</div>
              <div class="ShowIconVsIcon" @click="formCloseHandler('filter')">
                <i class="fas fa-arrow-left" style="font-size: 24px"></i>
              </div>
            </div>
            <div class="filterInputsWrapper">
              <div class="filterInputGroup">
                <input
                  class="filterGroupInput"
                  :placeholder="
                    $store.state.auth.role == 'builder' ||
                    $store.state.auth.role == 'customer'
                      ? 'عنوان آگهی'
                      : 'عنوان فایل'
                  "
                  v-model="fillter.text"
                  type="text"
                />
              </div>
              <div class="filterInputGroup">
                <DatePicker
                  clearable
                  v-model="fillter.date"
                  input-format="jYYYY-jMM-jDD"
                  format="YYYY-MM-DD"
                  placeholder="تاریخ را وارد کنید"
                />
              </div>
              <!-- <div class="filterInputGroup">
                <el-select
                  v-model="fillter.main_category"
                  :placeholder="
                    $store.state.auth.role == 'builder' ||
                    $store.state.auth.role == 'customer'
                      ? 'نوع آگهی'
                      : 'نوع فایل'
                  "
                  size="large"
                  style="
                    background: #f5f5f5;
                    min-width: 130px;
                    border-radius: 10px !important;
                    padding: 0 !important;
                  "
                >
                  <el-option :label="'همه'" :value="'all'" />
                  <el-option
                    v-for="(v, i) in $store.state.c_set.main_category"
                    :key="i"
                    :label="v"
                    :value="i"
                  />
                </el-select>
              </div> -->
              <div class="filterInputGroup">
                <el-select
                  v-model="fillter.order_by"
                  placeholder="مرتب سازی براساس"
                  size="large"
                  style="
                    background: #f5f5f5;
                    min-width: 130px;
                    border-radius: 10px !important;
                    padding: 0 !important;
                  "
                >
                  <el-option
                    v-for="item in sorts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
              <div
                v-if="
                  $store.state.auth.role != 'customer' &&
                  $store.state.auth.role != 'builder'
                "
                class="filterInputGroup"
              >
                <el-select
                  v-model="fillter.consultant"
                  placeholder="مشاور"
                  size="large"
                  style="
                    background: #f5f5f5;
                    min-width: 130px;
                    border-radius: 10px !important;
                    padding: 0 !important;
                  "
                >
                  <el-option :label="'همه مشاوران'" :value="0" />
                  <el-option
                    v-for="(item, i) in consultant_list"
                    :key="i"
                    :label="item.nickname"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <div class="filterBtnsWrapper">
              <div class="filterBTn" @click="load_post('first', true)">
                <div class="filterBtnTitle">
                  <span class="filterBtnTitleRes">نمایش</span> فیلتر
                </div>
                <div class="filterBtnIcon">
                  <VsxIcon
                    iconName="Setting4"
                    :size="14"
                    color="#fff"
                    type="linear"
                  />
                </div>
              </div>
              <div class="filterBTn lightBtn" @click="clearForm">
                <div class="filterBtnTitle">
                  پاکسازی فیلتر
                </div>
                <div class="filterBtnIcon">
                  <VsxIcon
                    iconName="Setting4"
                    :size="14"
                    color="#0096c7"
                    type="linear"
                  />
                </div>
              </div>
            </div>
          </div>
          <!--           <div class="resFilterWrapper" @click="filterOpenHandler"></div>-->
          <div class="archiveResFilter">
            <div class="resFilterWrapper">
              <div class="filterSearchWrapper">
                <input
                  type="search"
                  inputmode="search"
                  enterkeyhint="search"
                  class="searchInput"
                  v-model="fillter.text"
                  placeholder="جستجو فایل"
                  @keyup.enter="load_post('first')"
                />
                <div class="searchIcon">
                  <i class="fas fa-search"></i>
                </div>
              </div>

              <div class="filterToggle" @click="formTypeHandler('filter')">
                <VsxIcon
                  iconName="Setting4"
                  :size="20"
                  color="#000"
                  type="linear"
                />
              </div>
            </div>
            <div
              class="filesSwitchWrapper archiveSwitch"
              :class="categoryFilter"
            >
              <div class="switchToggler"></div>
              <div
                class="switchThumb all"
                @click="categoryFilterHandler('all')"
              >
                همه
              </div>
              <div
                class="switchThumb trade"
                @click="categoryFilterHandler('trade')"
              >
                فروش
              </div>
              <div
                class="switchThumb rent"
                @click="categoryFilterHandler('rent')"
              >
                اجاره
              </div>
            </div>
            <div class="resFilterWrapper">
              <div class="optionList">
                <Swiper slides-per-view="auto" :space-between="14">
                  <SwiperSlide>
                    <div
                      class="filterOption"
                      @click="catFilterHandler('all')"
                      :class="{ active: fillter.category == 'all' }"
                    >
                      همه
                    </div>
                  </SwiperSlide>
                  <SwiperSlide
                    v-for="(v, i) in $store.state.c_set.category"
                    :key="i"
                    @click="catFilterHandler(i)"
                  >
                    <div
                      class="filterOption"
                      :class="{ active: fillter.category == i }"
                    >
                      {{ v }}
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
          <div class="filesList" v-show="post_list.length > 0 && !isLoading">
            <div
              class="propertyThumb"
              v-for="(typeMelks, index) in post_list"
              :key="index"
              @click="showPost(typeMelks, index)"
            >
              <div class="propertyPic">
                <div class="propertyNums">
                  <div class="likesNum">
                    <div class="numsICON">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                        />
                      </svg>
                    </div>
                    <div class="numNumber">{{ typeMelks.likes }}</div>
                  </div>
                  <div class="commentsNum">
                    <div class="numsICON">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
                        />
                      </svg>
                    </div>
                    <div class="numNumber">{{ typeMelks.comments_count }}</div>
                  </div>
                </div>
                <div class="fileStatusThumb" :class="typeMelks.status">
                  {{ typeMelks.status_fa }}
                </div>
                <img
                  :src="typeMelks.avatar"
                  :alt="typeMelks.content"
                  @error="handleImageError"
                />
              </div>
              <div class="propertyContent">
                <div class="contanteHeader">
                  <div class="propertyCategory">
                    {{ typeMelks.main_category }}
                    <span v-if="typeMelks.main_category_en == 'request'">{{
                      typeMelks.request_type
                    }}</span>
                    - {{ typeMelks.category }}
                  </div>
                  <div class="propertyUpload">
                    <div class="propertyUploadIcon">
                      <VsxIcon
                        iconName="Calendar"
                        :size="14"
                        color="#0096c7"
                        type="linear"
                      />
                    </div>
                    <div class="propertyUploadTitle">
                      {{ typeMelks.created_fa }}
                    </div>
                  </div>
                </div>
                <div class="contentMain">
                  <div class="propertyTitle">
                    {{
                      typeMelks.content.length > 34
                        ? typeMelks.content.slice(0, 34) + "..."
                        : typeMelks.content
                    }}
                  </div>
                  <div class="propertyLocation">
                    <div class="locationIcon">
                      <i class="fa-solid fa-location-dot"></i>
                    </div>
                    <div class="locationTitle">
                      {{ typeMelks.address }}
                    </div>
                  </div>
                  <div class="contentFeaturesWrapper">
                    <div
                      v-if="
                        typeMelks.feature && typeMelks.feature.includes('fast')
                      "
                      class="featuresThumb fast"
                    >
                      <i class="fa-solid fa-bolt"></i>
                      <span>فوری</span>
                    </div>
                    <div
                      v-if="
                        typeMelks.feature &&
                        typeMelks.feature.includes('exchangeable')
                      "
                      class="featuresThumb exchange"
                    >
                      <i class="fa-solid fa-rotate"></i>
                      <span>قابل معاوضه</span>
                    </div>
                    <div
                      v-if="
                        typeMelks.feature &&
                        (typeMelks.feature.includes('single') ||
                          typeMelks.feature.includes('student'))
                      "
                      class="featuresThumb single"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="size-6"
                      >
                        <path
                          d="M11.7 2.805a.75.75 0 0 1 .6 0A60.65 60.65 0 0 1 22.83 8.72a.75.75 0 0 1-.231 1.337 49.948 49.948 0 0 0-9.902 3.912l-.003.002c-.114.06-.227.119-.34.18a.75.75 0 0 1-.707 0A50.88 50.88 0 0 0 7.5 12.173v-.224c0-.131.067-.248.172-.311a54.615 54.615 0 0 1 4.653-2.52.75.75 0 0 0-.65-1.352 56.123 56.123 0 0 0-4.78 2.589 1.858 1.858 0 0 0-.859 1.228 49.803 49.803 0 0 0-4.634-1.527.75.75 0 0 1-.231-1.337A60.653 60.653 0 0 1 11.7 2.805Z"
                        />
                        <path
                          d="M13.06 15.473a48.45 48.45 0 0 1 7.666-3.282c.134 1.414.22 2.843.255 4.284a.75.75 0 0 1-.46.711 47.87 47.87 0 0 0-8.105 4.342.75.75 0 0 1-.832 0 47.87 47.87 0 0 0-8.104-4.342.75.75 0 0 1-.461-.71c.035-1.442.121-2.87.255-4.286.921.304 1.83.634 2.726.99v1.27a1.5 1.5 0 0 0-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.66a6.727 6.727 0 0 0 .551-1.607 1.5 1.5 0 0 0 .14-2.67v-.645a48.549 48.549 0 0 1 3.44 1.667 2.25 2.25 0 0 0 2.12 0Z"
                        />
                        <path
                          d="M4.462 19.462c.42-.419.753-.89 1-1.395.453.214.902.435 1.347.662a6.742 6.742 0 0 1-1.286 1.794.75.75 0 0 1-1.06-1.06Z"
                        />
                      </svg>
                      <span>دانشجو/مجرد</span>
                    </div>
                  </div>
                  <div class="contentPriceWrapper">
                    <div
                      class="priceWrapper"
                      v-if="
                        typeMelks.main_category_en != 'rent' &&
                        !(
                          typeMelks.main_category_en == 'request' &&
                          typeMelks.request_type_en == 'rent'
                        )
                      "
                    >
                      <div
                        class="pricecTitle"
                        v-if="typeMelks.main_category_en == 'trade'"
                      >
                        قیمت فروش:
                      </div>
                      <div
                        class="pricecTitle"
                        v-if="typeMelks.main_category_en == 'request'"
                      >
                        قیمت خرید:
                      </div>
                      <div
                        v-if="typeMelks.main_category_en != 'request'"
                        class="priceValue"
                      >
                        {{ typeMelks.total_price }}
                      </div>
                      <div
                        v-if="typeMelks.main_category_en == 'request'"
                        class="priceValue"
                      >
                        {{ typeMelks.total_price }} تا
                        {{ typeMelks.total_price_max }}
                      </div>
                    </div>
                    <div
                      class="priceWrapper"
                      v-if="
                        typeMelks.main_category_en == 'rent' ||
                        (typeMelks.main_category_en == 'request' &&
                          typeMelks.request_type_en == 'rent')
                      "
                    >
                      <div class="pricecTitle">مبلغ رهن:</div>
                      <div
                        v-if="typeMelks.main_category_en != 'request'"
                        class="priceValue"
                      >
                        {{ typeMelks.mortgage_price }}
                      </div>
                      <div
                        v-if="typeMelks.main_category_en == 'request'"
                        class="priceValue"
                      >
                        {{ typeMelks.mortgage_price }} تا
                        {{ typeMelks.mortgage_price_max }}
                      </div>
                    </div>
                    <div
                      class="priceWrapper"
                      v-if="
                        typeMelks.main_category_en == 'rent' ||
                        (typeMelks.main_category_en == 'request' &&
                          typeMelks.request_type_en == 'rent')
                      "
                    >
                      <div class="pricecTitle">مبلغ اجاره:</div>
                      <div
                        v-if="typeMelks.main_category_en != 'request'"
                        class="priceValue"
                      >
                        {{ typeMelks.rent_price }}
                      </div>
                      <div
                        v-if="typeMelks.main_category_en == 'request'"
                        class="priceValue"
                      >
                        {{ typeMelks.rent_price }} تا
                        {{ typeMelks.rent_price_max }}
                      </div>
                    </div>
                  </div>
                  <div class="additionalWrapper">
                    <div
                      class="contentAdditional"
                      v-if="typeMelks.owner_tel || typeMelks.archive_desc"
                      :class="{ open: expandedIndex == index }"
                      @click.stop
                    >
                      <div
                        class="additionalHeader"
                        @click.stop="toggleAdditionalInfo(index)"
                      >
                        <svg
                          stroke="#0096c7"
                          fill="none"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          aria-hidden="true"
                          class="drop-icon"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M19 9l-7 7-7-7"
                          ></path>
                        </svg>
                        <span>اطلاعات تکمیلی</span>
                      </div>
                      <div class="additionalMain">
                        <div class="mainContainer">
                          <div class="contianerContent">
                            <div
                              class="contentThumb"
                              v-if="typeMelks.archive_desc"
                            >
                              <div class="thumbIcon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  fill="#0096c7"
                                  class="size-5"
                                >
                                  <path
                                    d="M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375z"
                                  ></path>
                                  <path
                                    fill-rule="evenodd"
                                    d="M3.087 9l.54 9.176A3 3 0 006.62 21h10.757a3 3 0 002.995-2.824L20.913 9H3.087zm6.163 3.75A.75.75 0 0110 12h4a.75.75 0 010 1.5h-4a.75.75 0 01-.75-.75z"
                                    clip-rule="evenodd"
                                  ></path>
                                </svg>
                              </div>
                              <div class="thumbContent">
                                <div class="contentTite">توضیحات آرشیو</div>
                                <div class="contentValue">
                                  {{ typeMelks.archive_desc }}
                                </div>
                              </div>
                            </div>
                            <div
                              class="contentThumb"
                              v-if="typeMelks.owner_tel"
                            >
                              <div class="thumbIcon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  fill="#0096c7"
                                  class="size-5"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                                    clip-rule="evenodd"
                                  ></path>
                                </svg>
                              </div>
                              <div class="thumbContent">
                                <div class="contentTite">تلفن مالک</div>
                                <div class="contentValue phoneValue">
                                  {{ typeMelks.owner_tel }}
                                </div>
                              </div>
                            </div>
                            <a
                              class="contentOption"
                              v-if="typeMelks.owner_tel"
                              :href="`tel:${typeMelks.owner_tel}`"
                            >
                              تماس با مالک
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="contentFooterFile">
                    <div
                      class="propertyBtnsWrapper"
                      :class="{ pending: typeMelks.status == 'pending' }"
                    >
                      <div
                        v-if="
                          editLoading != typeMelks.id &&
                          typeMelks.status != 'pending'
                        "
                        class="propertyBtn editBtn pointer"
                        @click.stop="formTypeHandler('edit', typeMelks.id)"
                      >
                        <div class="propertyBTnICON">
                          <i class="fas fa-edit"></i>
                        </div>
                        <div class="propertybTnTitle">ویرایش</div>
                      </div>
                      <div
                        v-if="editLoading == typeMelks.id"
                        class="propertyBtn editBtn pointer"
                      >
                        <span class="editLoader"></span>
                      </div>
                      <div
                        class="propertyBtn deleteBtn pointer"
                        @click.stop="del_post(typeMelks.id)"
                      >
                        <div class="propertyBTnICON">
                          <i class="fas fa-trash"></i>
                        </div>
                        <div class="propertybTnTitle">حذف</div>
                      </div>
                      <div
                        v-if="
                          typeMelks.status == 'inactive' ||
                          typeMelks.status == 'draft'
                        "
                        class="propertyBtn reAdsBtn pointer"
                        @click.stop="reAdsPost(typeMelks.id)"
                      >
                        <div class="propertyBTnICON">
                          <i class="fas fa-refresh"></i>
                        </div>
                        <div class="propertybTnTitle">آگهی شود</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="loadeMoreLoader" v-if="loadmore_loading">
            <span class="custom-loader"></span>
          </div>
          <div
            ref="loadMoreTrigger"
            class="trigger"
            v-show="post_list.length > 0 && !isLoading"
          ></div>
          <div
            v-if="post_list.length == 0 && !isLoading"
            class="justify-center align-center mt-4"
            style="text-align: center; height: 90%"
          >
            <img
              src="/img/notfound.png"
              alt="Alt text"
              width="320"
              height="280"
            />
            <h2 class="nothing" style="font-size: 14px">فایلی یافت نشد</h2>
          </div>
        </div>
      </el-scrollbar>
    </div>

    <EditMelk
      v-if="EditModel"
      :postId="postId"
      @close="formCloseHandler('edit')"
      @reloadPosts="load_post('first')"
    ></EditMelk>
  </div>
</template>

<script>
import DatePicker from "@alireza-ab/vue3-persian-datepicker";
import "@majidh1/jalalidatepicker/dist/jalalidatepicker.min.css";
import "@majidh1/jalalidatepicker";
// import { Skeletor } from "vue-skeletor";
import store from "@/store";
import EditMelk from "@/components/profile/editMelk";
import { nextTick } from "vue";
import { toast } from "vue3-toastify";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";

export default {
  name: "MyArchive",
  components: { EditMelk, Swiper, SwiperSlide, DatePicker },
  props: {
    BranchInfos: Object,
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      ShowModel: false,
      addFile: false,
      color: "",
      value: "",
      showFile: false,
      loadMoreTrigger: null,
      isFilterOpen: false,
      filterBackAction: false,
      editBackAction: false,
      filterStatus: "active",
      // categoryFilter: "all",
      sorts: [
        { value: "newest", label: "جدیدترین" },
        { value: "top_view", label: "پر بازدیدترین" },
        { value: "cheapest", label: "ارزان ترین" },
        { value: "expensive", label: "گران ترین" },
      ],
      divTop: "0",
      widthTop: "100%",
      dynamicStyles:
        "height: 0; overflow: hidden; transition: height 0.3s ease;",
      loadmore: false,
      loadmore_loading: false,
      editLoading: null,
      fillter: {
        main_category: "all",
        category: "all", //commercial
        text: "",
        location: "",
        min_width: 0,
        max_width: 0,
        min_price: 0,
        max_price: 0,
        min_rent_price: 0,
        max_rent_price: 0,
        min_mortageprice: 0,
        max_mortageprice: 0,
        bed: -1,
        min_age: 0,
        max_age: 0,
        min_floor: "0",
        max_floor: "0",
        min_totalFloor: "0",
        max_totalFloor: "0",
        min_Floorunit: "0",
        max_Floorunit: "0",
        docType: "0",
        // parking: false,
        // storage: false,
        // elevator: false,
        // photo: false,
        // newProperty: false,
        // special: false,
        advertiser: "all",
        district: "0",
        order_by: "newest",
        view_mode: "list",
        user_id: 0,
        city: 0,
        m_id: 0,
        page: 1,
        per_page: 12,
        date: "",
        role: "branch_admin",
        consultant: 0,
        status: "draft",
        list_type: "own_profile",
      },

      isLoading: false,
      post_list: [],
      consultant_list: [],
      postId: 0,
      formType: "",
      expandedIndex: null,
    };
  },
  watch: {
    showFile(newValue) {
      document.body.style.overflow = newValue ? "hidden" : "auto";
    },
    EditModel() {
      if (this.EditModel == false) {
        this.editLoading = null;
      }
    }
  },
  async mounted() {
    setInterval(() => {
      this.loadTheme();
    }, 100);

    if (this.$store.state.auth.loggedIn) {
      if (
        this.$store.state.auth.role == "branch_admin" ||
        this.$store.state.auth.role == "consultant"
      ) {
        const bInfo = JSON.parse(localStorage.getItem("branchinof"));
        if (bInfo) {
          this.fillter.branch_id = bInfo.id;
          this.fillter.user_id = this.$store.state.auth.uid;
        }
      } else {
        this.fillter.branch_id = null;
        this.fillter.user_id = this.$store.state.auth.uid;
      }
    }

    this.load_post("first");
    this.load_consultant();
    this.ShowToUser();
    window.jalaliDatepicker.startWatch({
      maxDate: "today",
    });
    await nextTick();
    this.loadMoreTrigger = this.$refs.loadMoreTrigger;
    this.$nextTick(() => {
      const wrap = this.$refs.scrollbar?.wrapRef;
      if (wrap) {
        wrap.addEventListener("scroll", this.handleScroll);
      }
    });
    // const observer = new IntersectionObserver(
    //   ([entry]) => {
    //     if (entry.isIntersecting) {
    //       this.load_post();
    //     }
    //   },
    //   { threshold: 1.0 }
    // );
    // if (this.loadMoreTrigger) {
    //   observer.observe(this.loadMoreTrigger);
    // }
  },
  beforeUnmount() {
    const wrap = this.$refs.scrollbar?.wrapRef;
    if (wrap) {
      wrap.removeEventListener("scroll", this.handleScroll);
    }
  },
  computed: {
    categoryFilter() {
      return this.fillter.main_category;
    },
    EditModel() {
      return this.$route.query.editing === "active";
    },
    showFilter() {
      return this.$route.query.filter === "active";
    }
  },
  methods: {
    catFilterHandler(cat) {
      if (this.fillter.category == cat) return;
      this.fillter.category = cat;
      this.load_post("first");
    },
    categoryFilterHandler(category) {
      // this.categoryFilter = category;
      this.fillter.main_category = category;
      this.load_post("first");
    },
    clearForm() {
      this.fillter = {
        main_category: "all",
        category: "all", //commercial
        text: "",
        location: "",
        min_width: 0,
        max_width: 0,
        min_price: 0,
        max_price: 0,
        min_rent_price: 0,
        max_rent_price: 0,
        min_mortageprice: 0,
        max_mortageprice: 0,
        bed: -1,
        min_age: 0,
        max_age: 0,
        min_floor: "0",
        max_floor: "0",
        min_totalFloor: "0",
        max_totalFloor: "0",
        min_Floorunit: "0",
        max_Floorunit: "0",
        docType: "0",
        // parking: false,
        // storage: false,
        // elevator: false,
        // photo: false,
        // newProperty: false,
        // special: false,
        advertiser: "all",
        district: "0",
        order_by: "newest",
        view_mode: "list",
        user_id: 0,
        city: 0,
        m_id: 0,
        page: 1,
        per_page: 12,
        date: "",
        role: "branch_admin",
        consultant: 0,
        status: "draft",
        list_type: "own_profile",
      };

      if (this.$store.state.auth.loggedIn) {
        if (
          this.$store.state.auth.role == "branch_admin" ||
          this.$store.state.auth.role == "consultant"
        ) {
          const bInfo = JSON.parse(localStorage.getItem("branchinof"));
          if (bInfo) {
            this.fillter.branch_id = bInfo.id;
            this.fillter.user_id = this.$store.state.auth.uid;
          }
        } else {
          this.fillter.branch_id = null;
          this.fillter.user_id = this.$store.state.auth.uid;
        }
      }
    },
    handleBackBtn() {
      history.back();
    },
    filterOpenHandler() {
      this.showFilter = true;
      history.pushState(null, "", location.href);
    },
    filterCloseHandler() {
      // if (!this.filterBackAction) {
      // }
      history.back();
      setTimeout(() => {
        this.showFilter = false;
      }, 500);
      this.clearForm();
    },
    load_post(param, close = false) {
      this.loadmore = true;
      this.loadmore_loading = true;
      this.fillter.page += 1;
      if (param == "first") {
        this.isLoading = true;
        this.post_list = [];
        this.fillter.page = 1;
      }

      this.fillter.branch_id = this.BranchInfos.id;
      this.helperPost("post-list", this.fillter).then((r) => {
        if (r.data.result == 0) {
          // this.post_list = [];
          if (param != "first") {
            this.fillter.page -= 1;
          }
        } else {
          this.post_list = this.post_list.concat(r.data.data.list);
          console.log("fileList", r.data.data);
          if (r.data.data.total_page == this.fillter.page) {
            this.loadmore = false;
          }
        }
        this.isLoading = false;
        this.loadmore_loading = false;
      });
      let windowWidth = window.innerWidth;
      if (windowWidth < 1000 && close) {
        this.formCloseHandler("filter");
      }
    },
    load_consultant() {
      this.helperPost("branch-users-list", { role: "consultant" }).then((r) => {
        this.consultant_list = r.data.list;
      });
    },
    handleScroll() {
      const scrollbarWrap = this.$refs.scrollbar?.wrapRef;

      if (!scrollbarWrap) return;

      const scrollTop = scrollbarWrap.scrollTop;
      const scrollHeight = scrollbarWrap.scrollHeight;
      const clientHeight = scrollbarWrap.clientHeight;

      // لیزی لود: اگر ۱۰۰ پیکسل مانده به انتهای لیست
      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (this.loadmore && !this.loadmore_loading) {
          this.load_post(); // متد لود داده‌هات
        }
      }

      // تغییر وضعیت یک div (مثلاً موقعیت فیلتر بالای صفحه)
      if (scrollTop > 100) {
        this.divTop = "top:20px; width:85%;margin: 0;right: 5%";
      } else {
        this.divTop = "top:80px; width:90%;margin: auto";
      }
    },

    ShowToUser() {
      this.showFile = true;
    },

    closeBtn() {
      history.back();
      document.body.style = "overflow-y: auto;";
    },

    loadTheme() {
      const width = window.innerWidth;
      this.color = width >= 1250 ? "#2dc653" : "#f5f5f5";
    },

    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;

      this.dynamicStyles = this.isFilterOpen
        ? "height: 416px; overflow: hidden; transition: height 0.3s ease;"
        : "height: 0; overflow: hidden; transition: height 0.3s ease;";

      if (this.isFilterOpen) {
        setTimeout(() => {
          this.dynamicStyles =
            "height: 416px; overflow: inherit; transition: height 0.3s ease;";
        }, 300);
      }
    },
    showPost(post, index) {
      localStorage.removeItem("post_detail");
      store.commit("post_detail_set", this.post_list[index]);
      this.$router.push(`/details/${post.id}/archived`);
      localStorage.setItem("openShowFile", true);
      localStorage.setItem("tComp", "MyArchive");
      console.log("branchinfo");
    },
    formTypeHandler(type, editId = null) {
      this.formType = type;
      this.formOpenHandler(type, editId);
    },
    formOpenHandler(type, editId = null) {
      if (type == "filter") {
        this.$router.push({
          query: {
            ...this.$route.query,
            filter: "active",
          },
        });
      } else if (type == "edit") {
        this.editLoading = editId;
        this.postId = editId;
        this.$router.push({
          query: {
            ...this.$route.query,
            editing: "active",
            step: "1",
          },
        });
      } else if (type == "add") {
        if (!this.$store.state.auth.loggedIn) {
          toast("برای ثبت آگهی وارد حساب کاربری خود شوید", {
            type: "error",
          });
          return;
        }
        if (
          this.$store.state.auth.loggedIn &&
          !this.$store.state.auth.is_complate
        ) {
          toast("برای ثبت آگهی اطلاعات پروفایل خود را تکمیل کنید", {
            type: "error",
          });
          return;
        }
        if (
          this.$store.state.auth.loggedIn &&
          this.$store.state.auth.role == "consultant" &&
          this.$store.state.auth.is_allowed == "no"
        ) {
          toast(
            "پروفایل شما تکمیل شده است، اما برای ثبت آگهی نیاز است هویت شما تایید شود.",
            {
              type: "error",
            }
          );
          return;
        }
        if (
          this.$store.state.auth.loggedIn &&
          this.$store.state.auth.role == "branch_admin" &&
          this.BranchInfos &&
          this.BranchInfos.is_allowed != "active"
        ) {
          toast(
            "پروفایل شما تکمیل شده است، اما برای ثبت آگهی نیاز است هویت شما تایید شود.",
            {
              type: "error",
            }
          );
          return;
        }
        // this.addFile = true;
        this.$router.push('/profile/CreateMelk?step=1')
      }
    },
    formCloseHandler(type = null) {
      history.back();
      if(type == 'edit') {
        this.load_post("first");
      }
    },

    // postSaveHandler() {
    // },
    reAdsPost(id) {
      this.$swal
        .fire({
          title: "آگهی فعال شود؟",
          text: "پس از این عملیات، آگهی در لیست آگهی های فعال قرار می‌گیرد.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "تایید",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              let self = this;
              console.log("post id", id);
              this.helperPost("change-status", {
                post_id: id,
                status: "pending",
              })
                .then((r) => {
                  if (r.data.result == "1") {
                    toast(r.data.msg, {
                      type: "success",
                      dangerouslyHTMLString: true,
                    });
                    self.load_post("first");
                  } else {
                    toast(r.data.msg, {
                      type: "error",
                      dangerouslyHTMLString: true,
                    });
                  }
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          }
        });
    },
    // del_post(id) {
    //   this.$swal
    //     .fire({
    //       title: "آگهی غیرفعال شود؟",
    //       text: "پس از این عملیات، آگهی در لیست آگهی های غیرفعال قرار می‌گیرد.",
    //       icon: "warning",
    //       showCancelButton: true,
    //       confirmButtonColor: "#0096c7",
    //       cancelButtonColor: "#fff",
    //       confirmButtonText: "تایید",
    //       cancelButtonText: "انصراف",
    //     })
    //     .then((result) => {
    //       if (result.isConfirmed) {
    //         if (result.value) {
    //           let self = this;
    //           console.log("post id", id);
    //           this.helperPost("change-status", {
    //             post_id: id,
    //             status: "inactive",
    //           })
    //             .then((r) => {
    //               if (r.data.result == "1") {
    //                 toast(r.data.msg, {
    //                   type: "success",
    //                   dangerouslyHTMLString: true,
    //                 });
    //                 self.load_post("first");
    //               } else {
    //                 toast(r.data.msg, {
    //                   type: "error",
    //                   dangerouslyHTMLString: true,
    //                 });
    //               }
    //             })
    //             .catch(function () {
    //               self.loading = false;
    //             });
    //         }
    //       }
    //     });
    // },

    toggleAdditionalInfo(index) {
      if (this.expandedIndex === index) {
        this.expandedIndex = null;
      } else {
        this.expandedIndex = index;
      }
    },
    del_post(id) {
      this.$swal
        .fire({
          title: "آگهی حذف گردد؟",
          text: "پس از این عملیات آگهی برای همیشه حذف میگردد.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "حذف",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              let self = this;
              this.helperPost("del-post", { post_id: id })
                .then((r) => {
                  if (r.data.result == "1") {
                    toast(r.data.msg, {
                      type: "success",
                      dangerouslyHTMLString: true,
                    });
                    self.load_post("first");
                  } else {
                    toast(r.data.msg, {
                      type: "error",
                      dangerouslyHTMLString: true,
                    });
                  }
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.topNav__searchbar_wrapper {
  width: 60% !important;
}
.loadButtonarea {
  width: 100%;
  margin-top: 36px;
}
.loadButtonarea .loadButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 48px;
  text-align: center;
  background: #2dc653;
  font-family: "iranyekanB", sans-serif;
  font-size: 0.9rem;
  color: #fff;
  border-radius: 8px;
  margin: 0 auto;
}
.loader {
  height: 40px;
  width: 40px;
  margin-top: 0 !important;
}

.editLoader {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.showFileBtns {
  display: grid;
  grid-template-columns: 49% 49%;
  justify-content: space-between;
}

.mobileFileTitle {
  display: none;
}

.fileStatusThumb {
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 6px 12px;
  border-radius: 24px;
  font-size: 0.8rem;
  background: #0096c7;
  color: #fff;
  z-index: 2;

  &.approved {
    background: #01d06f;
  }

  &.pending {
    background: #7f8c8d;
  }

  &.inactive {
    background: #f00;
  }
}

@media (max-width: 600px) {
  .desktopFileTitle {
    display: none !important;
  }

  .TopShowToUserCdn {
    position: relative;
    img {
      height: 242px;
    }
  }

  .mobileFileTitle {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: block;
    width: 100%;
    padding: 7px;
    font-family: "iranyekanB", sans-serif;
    font-size: 1rem;
    color: #fff;
    text-align: center;
    background: rgba(0, 0, 0, 0.7);
  }
}

.dark {
  .optionList {
    .filterOption {
      color: #fff;
      background: #101a23;
      border-color: #4c4c4c;
      box-shadow: 0 1px 3px 0 rgba(255, 255, 255, 0.1),
        0 1px 2px -1px rgba(255, 255, 255, 0.1);
    }
  }
}

.optionList {
  width: 100%;
  margin-top: -2px;
  margin-bottom: 4px;

  :deep(.swiper) {
    padding-bottom: 6px;
    padding-inline: 4px;
    .swiper-slide {
      width: auto !important;
    }
  }

  .filterOption {
    width: fit-content;
    padding: 6px 28px;
    font-size: 0.9rem;
    line-height: 1.5;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
      0 1px 2px -1px rgba(0, 0, 0, 0.1);
    transition: all 0.2s;
    border: 1px solid #eaeaea;

    &.active {
      color: #fff;
      background: #0096c7;
      border-color: #0096c7;
    }

    &:active {
      transform: scale(0.925);
    }
  }
}

.showFileMain {
  .mainFilterBox {
    .filterBtnsWrapper {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 18px;

      .filterBTn {
        &.lightBtn {
          background: transparent;
          border: 2px solid #0096c7;
          color: #0096c7;
        }
      }
    }
  }
}
</style>
